
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/pick-of-the-day",
      function () {
        return require("private-next-pages/blog/pick-of-the-day.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/pick-of-the-day"])
      });
    }
  